<template>
  <d-modal
    v-if="showModal"
    :key="currentOrder ? currentOrder.id : 0"
    class="crm-new-popup"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          Zapłata klienta:
          <p class="text-success font-weight-light ml-2 mt-2">{{customer.name ? customer.name : ''}}</p>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div
        class="spinner-load"
        v-if="hidden_spinner === false">
        <div
          class="spinner-border spinner-border-sm crm-new-popup-spinner"
          role="status"></div>
      </div>
      <validation-observer
        v-if="hidden_spinner === true"
        ref="orders-form-payment"
        tag="form">
        <d-alert
          v-if="customer.dept > 0"
          :theme="customer.dept > 0 ? 'danger' : 'success'"
          show>
          <div
            class="form-group mt-3"
            style="font-size: 1.2rem">
            <span class="font-weight-light"> Zadłużenie klienta:</span> <span>{{customer.dept !== 0 ? customer.dept.toFixed(2) : 0}}</span> zł<br />
            <span class="font-weight-light"> Liczba nieopłaconych zamówień:</span> <span>{{currentOrder.depth_orders_count}}</span><br />
          </div>
        </d-alert>
        <div class="form-group">
          <validation-provider
            :rules="'required'"
            name="payment_date"
            v-slot="{ errors }">
            <label for="payment_date">
              Data wpłaty:
            </label>
            <date-picker
              v-model="data.payment_date"
              class="stronger-input"
              valueType="format"
              style="width: 100%"/>
          </validation-provider>
          <div
            v-if="!data.payment_date"
            class="invalid-feedback"
            style="display: block;">
            To pole jest wymagane
          </div>
        </div>
        <div
          v-if="paymentMethods"
          class="form-group">
          <label for="settlement_method">Metoda płatności:</label>
          <div :class="{ 'form-control': true, 'is-select': true }">
            <v-select
              :options="paymentMethods"
              v-model="data.settlement_method"
              class="stronger-input"
              :reduce="method => method.id"
              placeholder="Wybierz metodę"
              label="id">
              <template
                slot="option"
                slot-scope="option">
                <div class="d-center">
                  {{ option.name }}
                </div>
              </template>
              <template
                slot="selected-option"
                slot-scope="option">
                <div class="selected d-center">
                  {{ option.name}}
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <div class="form-group">
          <label
            class="text-danger"
            for="price">
            Kwota zamówienia:
          </label>
          <validation-provider
            name="price"
            rules="required|min_value:0"
            v-slot="{ errors }">
            <d-input
              :disabled="true"
              :state="errors.length ? 'invalid' : null"
              :step="0.01"
              type="number"
              v-model="order_price" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group">
          <label for="amount">
            <template v-if="data.settlement_method === 'CASH'">
              Wpłacone gotówką:
            </template>
            <template v-else-if="data.settlement_method === 'TRANSFER'">
              Przelana kwota:
            </template>
            <template v-else>
              Opłacone kartą:
            </template>
          </label>
          <validation-provider
            name="amount"
            :rules="`required|min_value:0|max_value:${maxPaymentAmount}`"
            v-slot="{ errors }">
            <input
              :class="{
                'custom-input-new stronger-input form-control': true,
                'is-invalid': errors.length
              }"
              :step="0.01"
              :min="0.00"
              :max="maxPaymentAmount"
              :state="errors.length ? 'invalid' : null"
              type="number"
              v-model="data.amount" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            :class="{ 'isLoading' : form_submitting }"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="clearDataAll">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
      <div
        v-if="!currentOrder || !currentOrder.id"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>
      <orders-form-payment-confirm
        :close-modal="closeConfirmModal"
        :data-value="confirm_modal_data"
        :show-modal="confirm_modal_table"
        :customer="customer"/>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils';
import CalendarUtils from '@/utils/CalendarUtils';
import OrdersFormPaymentConfirm from './OrdersFormPaymentConfirm';
import DatePicker from 'vue2-datepicker';
import PaymentMethods from '@/data/payments-methods.js';

export default {
  name: 'orders-form-payment',
  components: { DatePicker, OrdersFormPaymentConfirm },
  data () {
    return {
      data: {
        amount: 0.00,
        payment_date: '',
        settlement_method: null
      },
      order_price: 0.00,
      customer: {},
      customer_loaded: false,
      load_error: false,
      form_submitting: false,
      confirm_modal_table: false,
      confirm_modal_data: []
    };
  },
  props: {
    closeModal: {
      required: true,
      type: Function
    },
    currentOrder: {
      default: () => {},
      type: Object
    },
    refresh: {
      required: true,
      type: Function
    },
    showModal: {
      required: true,
      type: Boolean
    }
  },
  computed: {
    hidden_spinner () {
      return this.customer_loaded;
    },
    maxPaymentAmount () {
      if (this.customer) {
        return this.customer.dept.toFixed(2);
      }

      let alreadyPaid = this.currentOrder.payment_transferred + this.currentOrder.payment_cash + this.currentOrder.payment_card;
      return (this.currentOrder.price - alreadyPaid).toFixed(2);
    },
    paymentMethods () {
      return PaymentMethods;
    }
  },
  watch: {
    'confirm_modal_table': function (value) {
      if (!value) {
        this.refresh();
        this.showModal = false;
      }
    },
    'showModal': function (value) {
      if (value === true) {
        this.initModal();
        return;
      }
      this.clearDataAll();
    }
  },
  methods: {
    initModal () {
      // first set to method from order, it will later be overwritten if necessary
      this.data.settlement_method = this.currentOrder.settlement_method;
      this.loadCustomer();
      let alreadyPaid = this.currentOrder.payment_transferred + this.currentOrder.payment_cash + this.currentOrder.payment_card;
      this.order_price = this.currentOrder.price.toFixed(2);
      this.data.amount = (this.currentOrder.price - alreadyPaid).toFixed(2);
      this.data.payment_date = CalendarUtils.formatDateForPHP(new Date());
    },
    closeConfirmModal () {
      this.confirm_modal_table = false;
      this.confirm_modal_data = false;
      this.closeModal();
    },
    clearDataAll () {
      this.data.settlement_method = null;
      this.data.amount = 0.00;
      this.data.payment_date = '';
      this.order_price = 0.00;
      this.customer = {};
      this.customer_loaded = false;
      this.load_error = false;
      this.closeModal();
    },
    loadCustomer () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/item/' + this.currentOrder.customer_id,
        outputKey: 'customer',
        loadedKey: 'customer_loaded',
        errorKey: 'load_error',
        successAction: (response) => {
          if (!this.data.settlement_method) {
            this.data.settlement_method = response.settlement_method;
          }

          if (!this.paymentMethods.find(item => item.id === this.data.settlement_method)) {
            console.error('unrecognized payment method ', this.data.settlement_method);
            this.load_error = true;
          }
        }
      });
    },
    validateForm () {
      if (this.data.settlement_method !== '') {
        FormUtils.validate(this.$refs['orders-form-payment'], this.submitForm);
      }
    },
    submitForm () {
      this.form_submitting = true;
      let formDataToSend = {
        amount: Number(this.data.amount),
        payment_date: this.data.payment_date,
        settlement_method: this.data.settlement_method
      };

      this.$http.post('/customers/add-payment/' + (this.currentOrder.customer_id), formDataToSend).then((data) => {
        this.form_submitting = false;
        this.confirm_modal_data = data.data.payments;
        this.confirm_modal_table = true;
      }).catch((error) => {
        console.error(error);
        Vue.swal({
          title: 'Modyfikacja płatności nie powiodła się. Spróbuj ponownie.',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.form_submitting = false;
      });
    },
  },
  beforeDestroy () {
    this.clearDataAll();
  }
};
</script>
<style lang="scss">
  .close {
    display: none;
  }
  .modal-title {
    width: 100%;
  }
  .custom-input-new, .custom-input-new-disabled {
     width: 100%;
     height: auto;
     padding: 0.4375rem 0.75rem;
     font-size: 0.8125rem;
     line-height: 1.5;
     font-weight: 300;
     will-change: border-color, box-shadow;
     border-radius: 0.25rem;
     outline: none;
   }
  .custom-input-new-disabled {
    cursor: no-drop;
   }
  .custom-input-new-invalid {
     width: 100%;
     height: auto;
     padding: 0.4375rem 0.75rem;
     font-size: 0.8125rem;
     line-height: 1.5;
     border: 1px solid var(--theme-color);
     font-weight: 300;
     will-change: border-color, box-shadow;
     border-radius: 0.25rem;
     outline: none;
     box-shadow: 0 5px 11.5px rgba(196, 24, 60, 0.1);
   }
  .swal2-modal {
    border: 1px solid var(--form-border-color) !important;
    box-shadow: 0 0 17px 6px rgba(0,0,0,0.1);
  }
</style>
